import {
  DateTimePicker,
  LocalizationProvider,
  deDE,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { de } from 'date-fns/locale';
import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import {
  castWithZeroTimezone,
  getZeroTimezoneStringFromDate,
} from './generic_helper';

interface IProps {
  dateValue: string | null;
  setDateValue: (value: string | null) => void;
  allowNull: boolean;
  allowPast: boolean;
  label?: string;
}

const PickerTextField = (props: TextFieldProps) => (
  <TextField
    {...props}
    inputProps={{
      ...props.inputProps,
      placeholder: '',
    }}
  />
);

export const CustomeDateTimePicker: React.FC<IProps> = props => {
  const getValue = (): Date | null => {
    if (!props.dateValue) {
      return null;
    }

    const returnValue = castWithZeroTimezone(props.dateValue);

    return isNaN(returnValue.getTime()) ? null : returnValue;
  };

  const setValue = (newValue: Date | null) => {
    if (newValue === null) {
      props.setDateValue(props.allowNull ? null : '');
    } else {
      props.setDateValue(getZeroTimezoneStringFromDate(newValue));
      /*
            let year = newValue.getFullYear();
            let month = newValue.getMonth()+1;
            let day = newValue.getDate();
            let hour = newValue.getHours();
            let minut = newValue.getMinutes();
    
            let dateTimeString = `${year}-${fillNumberToString(month)}-${fillNumberToString(day)} ${fillNumberToString(hour)}:${fillNumberToString(minut)}:00`;

            props.setDateValue(dateTimeString)
            */
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={de}
      localeText={
        deDE.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      <DateTimePicker
        ampm={false}
        format='dd.MM.yyyy HH:mm'
        slots={{ textField: PickerTextField }}
        slotProps={{
          field: {
            formatDensity: 'dense',
          },
          textField: {
            size: 'small',
            fullWidth: true,
            label: props.label,
          },
        }}
        value={getValue()}
        onChange={setValue}
        minDateTime={props.allowPast ? undefined : new Date()}
      />
    </LocalizationProvider>
  );
};
